type Props = {
  left: Record<string, unknown> | null;
  right: Record<string, unknown> | null;
  leftLabel: string;
  rightLabel: string;
};

function flatten(obj: Record<string, unknown> | null, prefix = ""): Map<string, string> {
  const map = new Map<string, string>();
  if (!obj) return map;
  for (const [k, v] of Object.entries(obj)) {
    const path = prefix ? `${prefix}.${k}` : k;
    if (v && typeof v === "object" && !Array.isArray(v)) {
      for (const [kk, vv] of flatten(v as Record<string, unknown>, path).entries()) {
        map.set(kk, vv);
      }
    } else {
      map.set(path, JSON.stringify(v));
    }
  }
  return map;
}

export function SnapshotDiff({ left, right, leftLabel, rightLabel }: Props): JSX.Element {
  const l = flatten(left);
  const r = flatten(right);
  const keys = Array.from(new Set([...l.keys(), ...r.keys()])).sort();

  return (
    <div className="overflow-hidden rounded border border-rule bg-surface">
      <header className="grid grid-cols-3 border-b border-rule bg-surface-2">
        <div className="px-3 py-2 font-mono text-meta uppercase tracking-wider text-ink-mute">field</div>
        <div className="border-l border-rule px-3 py-2 font-mono text-meta uppercase tracking-wider text-ink-mute">{leftLabel}</div>
        <div className="border-l border-rule px-3 py-2 font-mono text-meta uppercase tracking-wider text-ink-mute">{rightLabel}</div>
      </header>
      <div className="max-h-[60vh] overflow-y-auto">
        {keys.map((k) => {
          const lv = l.get(k) ?? "—";
          const rv = r.get(k) ?? "—";
          const same = lv === rv;
          return (
            <div key={k} className={`grid grid-cols-3 border-b border-rule ${same ? "" : "bg-warn/10"}`}>
              <div className="px-3 py-2 font-mono text-meta text-ink-soft">{k}</div>
              <div className="border-l border-rule px-3 py-2 font-mono text-meta text-ink">{lv}</div>
              <div className="border-l border-rule px-3 py-2 font-mono text-meta text-ink">{rv}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
